import { useCallback } from 'react'
import { useMutation } from '@apollo/react-hooks'

import IN_APP_MESSAGE_FRAGMENT from '../../../../graphql/fragments/in-app-message.gql'
import MARK_IN_APP_MESSAGE_READ_MUTATION from '../../../../graphql/mutations/mark-in-app-message-read.gql'

/**
 * Returns a handler that marks a message read for the account (all devices)
 * when it is still UNREAD, and updates the cached status so the unread
 * indicator clears without refetching the hub. Called by the notification hub
 * when the user opens a message, and by useSelectMessageCta when the
 * user selects a message's CTA.
 */
export const useMarkMessageRead = () => {
  const [markInAppMessageRead] = useMutation(MARK_IN_APP_MESSAGE_READ_MUTATION)

  return useCallback(message => {
    if (message.status !== 'UNREAD') return null

    return markInAppMessageRead({
      variables: { id: message.id },
      // false means it was already read (e.g. on another device) or is no
      // longer eligible; either way the hub should stop showing it as unread
      update: cache => {
        const fragmentOptions = {
          id: `InAppMessage:${message.id}`,
          fragment: IN_APP_MESSAGE_FRAGMENT
        }
        let cachedMessage = null
        try {
          cachedMessage = cache.readFragment(fragmentOptions)
        } catch (readError) {
          return
        }
        if (!cachedMessage) return

        cache.writeFragment({
          ...fragmentOptions,
          data: { ...cachedMessage, status: 'READ' }
        })
      }
    })
  }, [markInAppMessageRead])
}
